import { NotetakerPolicyCaptureMode } from "@/schema"

export function liveCaptureAllowed(source?: { capture_mode?: NotetakerPolicyCaptureMode } | null) {
  return source?.capture_mode !== "transcript_only"
}
